const TRUTHY = new Set(["1", "true", "yes"]);

/**
 * Holding page while Last Man Standing is closed between seasons: the root
 * layout drops the header, footer and page content in favour of a coming-soon
 * message.
 * Read per request: the root layout awaits `headers()`, so every route renders
 * dynamically and picks up the container environment without a rebuild.
 */
export function isWaitingScreenEnabled(): boolean {
  return TRUTHY.has((process.env.WAITING_SCREEN ?? "").trim().toLowerCase());
}

export const SKIP_WAITING_SCREEN_COOKIE = "SKIP_WAITING_SCREEN";

/** `1` / `true` / `yes`; anything else (including absent) means "don't skip". */
export function isSkipWaitingScreenValue(
  value: string | null | undefined,
): boolean {
  return TRUTHY.has((value ?? "").trim().toLowerCase());
}
